// extracted by mini-css-extract-plugin
module.exports = {"cellSize":"_3wQXU","largeBlock":"_6QlJH","smallBlock":"_3UDm-"};